<section class="rewards-listing comman-wrap">
  <div class="rewards-head">
    <div class="container">
      <div class="row">
        <div class="col-12 title text-right">
          <p class="cancel-txt" (click)="closeSheet()">CANCEL</p>
        </div>
        <div class="col-md-8 title animate__animated animate__fadeIn">
          <h2>Use rewards and offers</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="toggleBox animate__animated animate__fadeIn" (click)="toggleContent();">APPLY COUPON CODE
            <span>
              <img *ngIf="!showCpnCode" src="assets/icon/dropdown_downicon.svg" alt="arrow_down">
              <img *ngIf="showCpnCode" src="assets/icon/dropdown_upicon.svg" alt="arrow_up">
            </span>
          </p>
        </div>
        <div class="col-12 coupon-code-section" *ngIf="showCpnCode">
          <div class="box">
            <form [formGroup]="couponForm">
              <input #couponVal type="text" name="couponName" formControlName="couponName" maxlength="50"
                class="custom-coupon-box input-text" placeholder="Enter coupon code">
              <button type="button" class="text-btn" (click)="applyCoupon2();applyCouponCodeGA(couponVal.value)"
                *ngIf="!showRemoveBtn">APPLY</button>
              <button type="button" class="text-btn" (click)="removeCouponCode()" *ngIf="showRemoveBtn">REMOVE</button>
            </form>
            <span *ngIf="couponmessg" style="color: #00754a;font-family: 'SoDoSans_Regular';margin: 4px;">
              {{couponmessg}}
            </span>
            <span *ngIf="couponForm.get('couponName').hasError('pattern')"
              style="color: #e26262;font-family: 'SoDoSans_Regular'; margin: 4px;">
              Only Alphanumerics are allowed!
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="offers-content">
    <div class="col-12 text-center no-offers" *ngIf="noAOffers && noNAOffers && !showAppliedCpn">
      <img src="assets/images/No Offers found.svg" alt="no-store">
      <h6>No Offers Found!</h6>
    </div>
    <section class="applied-offers animate__animated animate__fadeIn"
      *ngIf="appliedCpnArray && appliedCpnArray.length>0">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2>Applied Offers</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6 mb-4" *ngFor="let data of appliedCpnArray;let i = index">
            <div class="card animate__animated animate__fadeIn">
              <div class="card-cut" [ngClass]="{'green-bg': data.promoType === 'msr-reward'}">
                <div class="top-card" [ngClass]="{'full-width': data['showDetails']}">
                  <div class="card-horizontal">
                    <div class="card-body">
                      <div class="reward-tag" *ngIf="data.promoType === 'msr-reward'">
                        <p>
                          <img src="assets/icon/reward_star.svg" alt="star-icon">
                          <span>REWARD</span>
                        </p>
                      </div>
                      <h3 class="card-title" [ngClass]="{'no-top-pd': data.promoType === 'msr-reward'}">{{data.title}}
                      </h3>
                      <ng-container *ngIf="data?.content">
                        <p *ngIf="!data['showDetails']" [innerHtml]="data?.content | textLimit :60">
                        </p>
                      </ng-container>
                      <p *ngIf="data['showDetails']" [innerHtml]="data?.content">
                      </p>
                      <h6 *ngIf="!data['showDetails']">
                        EXPIRES ON : {{data?.expiryDate | date: 'dd/MM/yyyy'}}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottom-card">
                <div class="footer2">
                  <div [ngClass]="{'shimmer-loader-button': isClicked}">
                    <button type="button" (click)="removeCoupon(data,i)" class="custom-btn btn-black btn-sm-rounded"
                      [ngClass]="{'br animate-button-black' : isClicked && i==removeItemIndex}">
                      Remove
                    </button>
                  </div>
                  <div class="detail">
                    <h3 (click)="detailCoupon(data)">
                      <a>{{data['showDetails'] ? 'Done' : 'Details'}}</a>
                    </h3>
                  </div>
                </div>
              </div>
              <span class="coffee-pic" *ngIf="!data['showDetails']">
                <img src="{{data['couponImageUrl']}}" (error)="data['couponImageUrl'] ='assets/icon/Mask Group.svg'"
                  alt="mask-grop">
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="applicable-offers animate__animated animate__fadeIn"
      *ngIf="applicableOffersArrayNew && applicableOffersArrayNew.length>0;">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2>Applicable Offers</h2>
          </div>
        </div>
        <div class="row ">
          <div class="col-lg-4 col-md-6 mb-4" *ngFor="let data of applicableOffersArrayNew;let i = index">
            <div class="card">
              <div class="card-cut"
                [ngClass]="{'card-cut-align':showEligibleProducts && i == itemIndex , 'green-bg': data.promoType === 'msr-reward'}">
                <div class="top-card" [ngClass]="{'full-width': data['showDetails']}">
                  <div class="card-horizontal">
                    <div class="card-body">
                      <div class="reward-tag" *ngIf="data.promoType === 'msr-reward'">
                        <p>
                          <img src="assets/icon/reward_star.svg" alt="star-icon">
                          <span>REWARD</span>
                        </p>
                      </div>
                      <h3 class="card-title" [ngClass]="{'no-top-pd': data.promoType === 'msr-reward'}">{{data.title}}
                      </h3>
                      <ng-container *ngIf="data.content">
                        <p *ngIf="!data['showDetails']" [innerHtml]="data?.content | textLimit :60">
                        </p>
                      </ng-container>
                      <p *ngIf="data['showDetails']" [innerHtml]="data?.content">
                      </p>
                      <h6 *ngIf="!data['showDetails']">
                        EXPIRES ON : {{data?.expiryDate | date: 'dd/MM/yyyy'}}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottom-card" [ngClass]="{'card-cut-align':showEligibleProducts && i == itemIndex}">
                <div class="footer2">
                  <div [ngClass]="{'shimmer-loader-button': isClicked}">
                    <button type="button" (click)="useReward(data,i);useOfferClickGA(data.title)"
                      class="custom-btn btn-green btn-sm-rounded"
                      [ngClass]="{'br animate-loader' : isClicked && i==itemIndex}">Apply
                    </button>
                  </div>
                  <div class="detail">
                    <h3 (click)="detailCoupon(data);offersDetailGA(data['showDetails'])">
                      <a>{{data['showDetails'] ? 'Done' : 'Details'}}</a>
                    </h3>
                  </div>
                </div>
              </div>
              <span class="coffee-pic" *ngIf="!data['showDetails']">
                <img src="{{data['couponImageUrl']}}" (error)="data['couponImageUrl'] ='assets/icon/Mask Group.svg'" alt="coupon image">
              </span>
              <div class="radio-btn" *ngIf="showEligibleProducts && i == itemIndex">
                <ng-container
                  *ngIf="(data.offerCategory === 'bxgy' || data.offerCategory === 'bogo');else other_content">
                  <p class="mb-2" *ngFor="let product of data?.items">
                    <mat-radio-button (change)="selectedOffer(data,product)" *ngIf="product.isApplicablePromoItem">
                      <p class="mb-0 d-flex justify-content-between">
                        <span style="font-family: 'SoDoSans_Regular';">{{product.promoItemName}}</span>
                        <span style="color: #1a3c33;
                                    font-family: 'SoDoSans_Regular';">-₹{{product.discountAmount}}</span>
                      </p>
                    </mat-radio-button>
                  </p>
                </ng-container>
                <ng-template #other_content>
                  <p class="mb-2" *ngFor="let product of data?.items">
                    <mat-radio-button (change)="selectedOffer(data,product)" *ngIf="product.isApplicableItem">
                      <p class="mb-0 d-flex justify-content-between">
                        <span style="font-family: 'SoDoSans_Regular';">{{product.itemName}}</span>
                        <span style="color: #1a3c33;
                                      font-family: 'SoDoSans_Regular';">-₹{{product.discountAmount}}</span>
                      </p>
                    </mat-radio-button>
                  </p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ng-template #shimmer_content>
      <section class="applicable-offers">
        <div class="container">
          <div class="row mt-3">
            <div class="col">
              <swiper [config]="config" [pagination]="{
          type: 'fraction'
        }" #usefulSwiper [spaceBetween]="50" [autoHeight]="true" (swiper)="setControlledSwiper($event)"
                [navigation]="false" [pagination]="{ clickable: true }">
                <ng-template swiperSlide *ngFor="let data of  [0,1,2]">
                  <div class="main-card">
                    <div class="main-card-inner">
                      <div class="order-card">
                        <div class="card2 mb-2">
                          <div class="shimmer-wrap shimmer-card shimmer-bg">
                            <div class="wrapper">
                              <div class="py-2 px-4 d-flex justify-content-between align-items-center">
                                <div class="w-75">
                                  <p class="comment-second br animate w-40"></p>
                                  <p class="comment-second br animate w-75"></p>
                                  <p class="comment-second br animate w-60"></p>
                                </div>
                              </div>
                              <div class="px-2 d-flex justify-content-between align-items-center bottom-section">
                                <p class="comment br animate w-20"></p>
                                <p class="shimmer-button br animate w-20"></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </swiper>
            </div>
          </div>
        </div>
      </section>
    </ng-template>
    <section class="non-applicable-offers" [ngClass]="{'bottom-spacing':appliedCpnArray && appliedCpnArray.length>0}"
      *ngIf="nonAppDetailArr && nonAppDetailArr.length>0">
      <div class="container">
        <div class="row">
          <div class="col-12 mt-4">
            <h2>Other Offers</h2>
          </div>
        </div>
        <div class="row ">
          <div class="col-lg-4 col-md-6 mb-4" *ngFor="let data of nonAppDetailArr;let i = index">
            <div class="card">
              <div class="card-cut">
                <div class="top-card" [ngClass]="{'full-width': rewardText == data['showDetails']}">
                  <div class="card-horizontal">
                    <div class="card-body">
                      <div class="reward-tag" *ngIf="data.promoType === 'msr-reward'">
                        <p>
                          <img src="assets/icon/reward_star.svg" alt="star-icon">
                          <span>REWARD</span>
                        </p>
                      </div>
                      <h3 class="card-title" [ngClass]="{'no-top-pd': data.promoType === 'msr-reward'}">{{data.title}}
                      </h3>
                      <ng-container *ngIf="data.content">
                        <p *ngIf="!data['showDetails']" [innerHtml]="data?.content | textLimit :60">
                        </p>
                      </ng-container>
                      <p *ngIf="data['showDetails']" [innerHtml]="data?.content">
                      </p>
                      <h6 *ngIf="!data['showDetails']">
                        EXPIRES ON : {{data?.endDate | date: 'dd/MM/yyyy'}}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottom-card">
                <div class="footer2">
                  <div>
                    <button type="button" [disabled]="true" class="custom-btn btn-green btn-sm-rounded">Apply</button>
                  </div>
                  <div class="detail">
                    <h3 (click)="detailCoupon(data)"><a>{{data['showDetails'] ? 'Done' : 'Details'}}</a></h3>
                  </div>
                </div>
              </div>
              <span class="coffee-pic" *ngIf="!data['showDetails']">
                <img src="{{data['couponImageUrl']}}" (error)="data['couponImageUrl'] ='assets/icon/Mask Group.svg'">
              </span>
            </div>
          </div>
        </div>
        <div class="row" style="height: 200px;" *ngIf="!isPhone">
        </div>
      </div>
    </section>
  </div>
  <div class="price-details fixed-bottom-footer3" *ngIf="appliedCpnArray && appliedCpnArray.length>0">
    <div class="container">
      <div class="row">
        <div class="col-6">
          <div class="left-section">
            <p>
              <span class="discount-badge">Discount</span>
              <span class="offers-applied">{{appliedCpnArray && appliedCpnArray.length}} Offers Applied</span>
            </p>
            <p>Total Revised Cart Value</p>
          </div>
        </div>
        <div class="col-6 section-align-center">
          <div class="right-section">
            <p>
              <span class="original-total">₹ {{totalCartAmt | priceformat:'integer'}}<span
                  class="round-figure">.{{totalCartAmt| priceformat:'decimal'}}</span>
              </span>
              <span class="discounted-total">₹ {{totalOrderAmt | priceformat:'integer'}}<span
                  class="round-figure">.{{totalOrderAmt | priceformat:'decimal'}}</span></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fixed-bottom-footer4">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="btn-wrapper text-right">
            <button class="btn goto-cart-btn" (click)="closeSheet()">Go to Cart</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
